export const formatDateDDMonth = (dateString, ctx) => { // ctx is required
    try {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = [
            ctx.$t('monthsShortNameJan'),
            ctx.$t('monthsShortNameFeb'),
            ctx.$t('monthsShortNameMar'),
            ctx.$t('monthsShortNameApr'),
            ctx.$t('monthsShortNameMai'),
            ctx.$t('monthsShortNameJun'),
            ctx.$t('monthsShortNameJul'),
            ctx.$t('monthsShortNameAug'),
            ctx.$t('monthsShortNameSep'),
            ctx.$t('monthsShortNameOct'),
            ctx.$t('monthsShortNameNov'),
            ctx.$t('monthsShortNameDec'),
        ]
        const month = monthNames[date.getMonth()];
    
        return `${day} ${month}`;
    } catch (error) {
        throw new Error('context of app is required in formatDateDDMonth')
    }
}

export const formatDateDDMMYYYY = (dateString) => {
    const date = new Date(dateString)
  
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
  
    return `${day}.${month}.${year}`
}